(() => {
  const dialog = document.getElementById('DeichGuaranteeDialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  let opener;
  let previousOverflow;
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-deich-guarantee]');
    if (!trigger) return;
    event.preventDefault();
    opener = trigger;
    previousOverflow = document.body.style.overflow;
    dialog.showModal();
    dialog.scrollTop = 0;
    document.body.style.overflow = 'hidden';
  });
  dialog.querySelector('[data-deich-guarantee-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow || '';
    if (opener && opener.isConnected) opener.focus();
  });
})();